import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import {
  StyledCTASection,
  GradientBlob1,
  GradientBlob2,
  ContentContainer,
  CTATitle,
  CTASubtitle,
  ButtonGroup,
} from "./CTASection.styles";

export const CTASection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledCTASection>
      <GradientBlob1 />
      <GradientBlob2 />
      <ContentContainer>
        <CTATitle>{t("home.cta.title")}</CTATitle>
        <CTASubtitle>{t("home.cta.subtitle")}</CTASubtitle>
        <ButtonGroup>
          <Button
            type="primary"
            size="large"
            style={{
              height: 56,
              paddingInline: 40,
              fontSize: 16,
              fontWeight: 600,
              boxShadow: "0 8px 24px rgba(108, 92, 231, 0.4)",
              borderRadius: 28,
            }}
          >
            {t("home.cta.findSpecialist")}
          </Button>
          <Button
            size="large"
            style={{
              height: 56,
              paddingInline: 40,
              fontSize: 16,
              fontWeight: 600,
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              color: "white",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: 28,
            }}
          >
            {t("home.cta.becomePartner")}
          </Button>
        </ButtonGroup>
      </ContentContainer>
    </StyledCTASection>
  );
};
